import React, { useContext, useState } from "react";
import { ImCross, ImArrowRight } from "react-icons/im";
// import './CategoryList.css'; // Import your CSS file if you have one
import hcm2 from "../../Img/HCM.png";
import Erp2 from "../../Img/ERP.png";
import EPM from "../../Img/EPM.png";
import SCM from "../../Img/SCM-New.png";
import { Link, useNavigate } from "react-router-dom";
import RightArrow from "../../Img/right_7356257.png";
import DownArrow from "../../Img/down_2486595.png";
import { useEffect } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../utils/config";
import { toast } from "react-toastify";
import GlobalContext from "../../context/GlobalContext";
const CategoryList = ({ collaps, toggle, selectIcon }) => {
  const { catetoryIconUptated } = useContext(GlobalContext);

  // alert(selectIcon)
  const [openCategory, setOpenCategory] = useState(null);
  const [toggleIcon, settoggleIcon] = useState(RightArrow);
  const [subCategoryName, setSubCtegoryName] = useState("");
  const [showCreateSubCategory, setShowCreateSubCategory] = useState(true);

  //
  let imgArr = [hcm2, Erp2, EPM, SCM];
  const [apiResponse, setApiRespose] = useState([]);

  let bearerToken = localStorage.getItem("jwt_token");
  const config = {
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      "Content-Type": "application/json",
    },
  };

  //
  useEffect(() => {
    // alert("kjfvj")
    // const apiUrl = `${API_BASE_URL}/wp-json/wp/v2/categories?per_page=100`
    const apiUrl = `${API_BASE_URL}/wp-json/custom-category/v1/get-all-categories`;
    axios
      .get(apiUrl, config)
      .then((res) => {
        setApiRespose(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [catetoryIconUptated]);

  //
  const navigate = useNavigate();
  let getAllCat = [
    {
      id: 0,
      Image: "",
      title: "",
      content: [],
    },
  ];
  let demoArr = [];
  for (let i = 0; i < apiResponse.length; i++) {
    demoArr.push({
      id: 0,
      Image: "",
      title: "",
      content: [],
    });
  }
  // console.log("70=", apiResponse);
  for (let i = 0; i < apiResponse.length; i++) {
    if (apiResponse[i].parent == 0) {
      demoArr[i].title = apiResponse[i].name;
      demoArr[i].id = apiResponse[i].id;
      demoArr[i].Image = apiResponse[i].image;
    }

    for (let j = 0; j < apiResponse.length; j++) {
      if (apiResponse[i].id == apiResponse[j].parent) {
        demoArr[i].content.push(apiResponse[j]);
      }
    }
  }

  const filteredArray = demoArr.filter((obj) => obj.id !== 0);

  // Resulting array after filtering
  // console.log("91=", filteredArray)

  // for (let i = 0; i < filteredArray.length; i++) {
  //   filteredArray[i].Image = imgArr[i];
  // }

  //

  const toggleCategory = (index) => {
    if (openCategory === index) {
      setOpenCategory(null);
      settoggleIcon(RightArrow);
    } else {
      setOpenCategory(index);
      // settoggleIcon(DownArrow)
    }
  };

  const catagoryHandle = (catId) => {
    // alert(catId)
    localStorage.setItem("catagoryId", catId);
    navigate("/subcategory");
  };
  const subCatagoryHandle = (id) => {
    localStorage.setItem("subcategoryId", id);
    navigate("/category-posts");
  };

  // create subcategory

  const handleCreateSubcategoryOpen = (val) => {
    // alert(val)
    setShowCreateSubCategory(val);
  };
  const handleChangeSubCat = (e) => {
    setSubCtegoryName(e.target.value);

    console.log(e.target.value);
  };

  // create subcategory

  return (
    <div className="categories w-100 ">
      {/* <div> */}
      {selectIcon == "right" ? (
        <p
          className="text-white ps-4   "
          style={{ width: "95%", fontSize: "18px" }}
        >
          CATEGORIES
        </p>
      ) : (
        ""
      )}

      <ul className="category-list">
        {filteredArray?.map((category, index) => (
          <li className="m-0" key={index}>
            <p
              className=""
              // className={`category-title ${openCategory === index ? 'open' : ''}`}
            >
              {/* {console.log(category)} */}
              <div className=" text-dark">
                {/* <img className='m-0' style={{ width: '4%' }} src={category.Image} alt={category.title} /> */}
                <div className="me-3">
                  {/* <img src={category.Image} alt="" width={30} className='m-0' /> */}
                </div>
                <div>
                  <span onClick={() => toggleCategory(index)}>
                    <img
                      className="m-0"
                      style={{ width: selectIcon == "right" ? "8%" : "100%" }}
                      src={category.Image}
                      alt=""
                    />
                  </span>{" "}
                  <span
                    onClick={() => catagoryHandle(category.id)}
                    className="hyperlinkCard3 "
                    to="/searchLandingPage"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarNav"
                  >
                    {selectIcon == "right" ? category.title : ""}
                  </span>
                </div>
              </div>
            </p>

            {openCategory === index && (
              <div
              // className="category-content"
              >
                <ul style={{ listStyleType: "square" }} className="ps-5">
                  {selectIcon == "right" ? (
                    <div>
                      {category?.content.map((content, contentIndex) => {
                        return (
                          <li key={contentIndex} className="text-white">
                            <span
                              data-bs-toggle="collapse"
                              data-bs-target="#navbarNav"
                              onClick={() => subCatagoryHandle(content.id)}
                              to={content.route}
                              className="m-0 hyperlinkCard3 "
                            >
                              {content.name}
                            </span>
                          </li>
                        );
                      })}

                      {/* {showCreateSubCategory ?
                        <button className='btn btn-primary' onClick={() => handleCreateSubcategoryOpen(false)}>
                          Create SubCategory
                        </button> :
                        < div className='d-flex justify-content-between'>
                          <input
                            type="text"
                            placeholder="Enter subcategory name"
                            // value={newSubcategory[category.id]}
                            onChange={(e) =>
                              handleChangeSubCat(e)
                            }
                          />
                          <button className='btn btn-primary' onClick={() => handleCreateSubcategory(category.id, true)}>
                            Create
                          </button>
                        </div>
                      } */}
                    </div>
                  ) : (
                    ""
                  )}
                </ul>
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CategoryList;
